import { format } from 'date-fns';

export default (date?: string): string => {
  if (date) {
    return format(new Date(date), 'MMMM do, yyyy');
  }

  return format(new Date(), 'MMMM do, yyyy');
};
